import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditClient from './EditClient'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'
import ClientNotFound from './ClientNotFound'

import Resource from '../../stores/resource'
const ClientStore = Resource('clients')

class EditClientPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      client: {},
      error: '',
      loading: true
    }
  }

  componentDidMount() {
    ClientStore.find(this.props.match.params.id)
    .then((result) => this.setState({client: result.data, loading: false}))
    .catch((error) => this.setState({client: {}, error: errors.unpack(error), loading: false}))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      client,
      error,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(client)) return <ClientNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Edit Client
          </PageTitle>
        </header>

        <EditClient client={client} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditClientPage



// WEBPACK FOOTER //
// ./src/components/Clients/EditClientPage.jsx